import { useEffect, useState } from "react";
import { format } from "date-fns";
import { api } from "@/lib/api";
import type { WeeklyLog } from "@/lib/types";

export function Weekly() {
  const [rows, setRows] = useState<WeeklyLog[]>([]);
  const [date, setDate] = useState(format(new Date(), "yyyy-MM-dd"));
  const [weight, setWeight] = useState("");
  const [waist, setWaist] = useState("");
  const [notes, setNotes] = useState("");
  const [saving, setSaving] = useState(false);

  async function load() { setRows(await api.weeklyList()); }
  useEffect(() => { load(); }, []);

  async function submit(e: React.FormEvent) {
    e.preventDefault();
    setSaving(true);
    try {
      await api.weeklyUpsert({
        week_ending: date,
        weight_kg: weight ? Number(weight) : null,
        waist_cm: waist ? Number(waist) : null,
        notes: notes || null,
      });
      setWeight(""); setWaist(""); setNotes("");
      await load();
    } catch (err) { alert(String(err)); } finally { setSaving(false); }
  }

  return (
    <div className="space-y-4">
      <div>
        <h1 className="text-2xl font-semibold">Weekly check-in</h1>
        <p className="text-sm text-muted">Sunday AM, post-bathroom, pre-food.</p>
      </div>
      <form onSubmit={submit} className="card space-y-3">
        <div className="grid grid-cols-3 gap-3">
          <div>
            <label className="label">Date</label>
            <input type="date" className="field" value={date} onChange={(e) => setDate(e.target.value)} />
          </div>
          <div>
            <label className="label">Weight (kg)</label>
            <input type="number" step="0.1" inputMode="decimal" className="field"
              value={weight} onChange={(e) => setWeight(e.target.value)} />
          </div>
          <div>
            <label className="label">Waist (cm)</label>
            <input type="number" step="0.1" inputMode="decimal" className="field"
              value={waist} onChange={(e) => setWaist(e.target.value)} />
          </div>
        </div>
        <div>
          <label className="label">Notes</label>
          <input className="field" value={notes} onChange={(e) => setNotes(e.target.value)} />
        </div>
        <button className="btn-primary" disabled={saving}>{saving ? "Saving…" : "Save"}</button>
      </form>

      <div className="card">
        <h3 className="font-semibold mb-2">History</h3>
        <div className="space-y-1 text-sm font-mono">
          {rows.map((r) => (
            <div key={r.week_ending} className="flex justify-between border-b border-border py-1">
              <span className="text-muted">{r.week_ending}</span>
              <span>{r.weight_kg ?? "—"} kg · {r.waist_cm ?? "—"} cm</span>
            </div>
          ))}
          {rows.length === 0 && <p className="text-muted">No entries yet.</p>}
        </div>
      </div>
    </div>
  );
}
